import { axiosInstance as axios } from 'helpers/axiosInstance';
import logger from 'helpers/logger';
import { queryCmsContent } from './_api';

//CMS is not exposed to the website, therefore we fetch the tags via a Next.JS API
export const getTagsFromApi = async (rootId: number): Promise<Tags.Tag[]> => {
	return axios({
		url: `/api/tags`,
		method: 'POST',
		headers: {},
		data: {
			rootId,
		},
	})
		.then((res) => {
			const articles: Tags.Tag[] = res.data;
			return articles;
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			logger.error(`getTagsFromApi() \nTags retrieval from API failed \n${message}`);
			throw message;
		});
};

export const getTagsFromCms = async (rootId: number): Promise<Tags.Tag[]> => {
	const graphQLquery = `{
		pageSearch(
			documentType:["tag"] 
			rootIds:[${rootId}] 

			)
			{
				pages {
					key
					name
					id
				}
			}
		}`;

	const profiler = logger.startTimer();
	try {
		const results = await queryCmsContent({
			query: graphQLquery,
			method: 'POST',
		});
		return results.pageSearch?.pages.map(
			(tag): Tags.Tag => ({
				tagName: tag.name,
				id: tag.id,
				guid: tag.key,
			}),
		);
	} finally {
		profiler.done({ message: 'getTags', level: 'debug' });
	}
};
